import { CONTENT_SECTION_KEYS } from '../../../constants/comman';
import axios from '../../../services/axios';
import { axiosNTL } from '../../../services/axios';

import CourseData from '../types/CourseData';
import CourseSyllabusData from '../types/CourseSyllabusData';

const list = (selectedTab?: string) => {
	let url = '/course/getAvailableCourseListing'+  (selectedTab === CONTENT_SECTION_KEYS.FTRE ? `?specialPurposes=${selectedTab}` : '');
	return axiosNTL.get(url)
		.then((res: any) => {
			const courses: CourseData[] = res.responseObject;
			return Promise.resolve(courses);
		});
}
const getAllCourses = () => axiosNTL
	.get(`/package/listPackage?Archive=false`)
	.then((res: any) => {
	  const courses = res.responseObject;
	  return Promise.resolve(courses);
	});
const getCourseSubject = (courseId: string) => axiosNTL
	.get(`/courseSyllabus/getSubjects/${courseId}`)
	.then((res: any) => {
		const courseSyllabus: CourseSyllabusData[] = res.responseObject;
		return Promise.resolve(courseSyllabus);
	});

const getCourseSubSubject = (courseId: string, subjectId: string) => axiosNTL
	.get(`/courseSyllabus/getSubSubjects/${courseId}/${subjectId}`)
	.then((res: any) => {
		const courseSyllabus: CourseSyllabusData[] = res.responseObject;
		return Promise.resolve(courseSyllabus);
	});

const getCourseChapters = (courseId: string, subSubjectId: string) => axiosNTL
	.get(`/courseSyllabus/getChapters/${courseId}/${subSubjectId}`)
	.then((res: any) => {
		const courseSyllabus: CourseSyllabusData[] = res.responseObject;
		return Promise.resolve(courseSyllabus);
	});

const getCourseConcepts = (courseId: string, subjectId: string, chapterId: string) => axiosNTL
	.get(`/courseSyllabus/getConcepts/${courseId}/${subjectId}/${chapterId}`)
	.then((res: any) => {
		const courseSyllabus: CourseSyllabusData[] = res.responseObject;
		return Promise.resolve(courseSyllabus);
	});

 
const getCountByType = async (type: string, courseId: string, parentId: string) => axiosNTL
	.get(`/courseSyllabus/getCountByType/${type}?courseId=${courseId}&parentId=${parentId}`)
	.then((res: any) => {
		return Promise.resolve(res.responseObject);
	});

const courseService = {
	list,
	getCourseSubject,
	getCourseSubSubject,
	getCourseChapters,
	getCourseConcepts,
	getCountByType,
	getAllCourses
};

export default courseService;